import script from "./adminVideoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./adminVideoModal.vue?vue&type=script&setup=true&lang=js"

import "./adminVideoModal.vue?vue&type=style&index=0&id=3ec74ed3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ec74ed3"]])

export default __exports__